/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/camelcase */
import { ImageSize } from '../../cms/blocks/types.gen'

export type ExtraImages =
  // Old Page Header + CTA block:
  | '640w'
  | '1280w'
  | '1920w'
  | '2880w'

  // New Page Header:
  | '425w'
  | '850w'
  | '1225w'

  // Grid Block + Stories Block:
  | 'grid'
  | '720x470'
  | '1440x940'

  // Text + Image block:
  | '720w'
  | '1440w'

  // Media block:
  | 'media'
  | '460w'
  | '920w'
  | '1840w'

  // Quotes - Time-Line - Featured Content Blocks:
  | '450x450'
  | '600x600'
  | '1200x1200'

  // CTA Block:
  | '700w'
  | '1400w'
  | '2800w'

  // OLD PROJECT - Featured Content Block + Media Block + Image Gallery + Page Header:
  | '640w'
  | '1280w'
  | '1920w'
  | '2880w'

  // Quote Block:
  | '640x360'
  | '1280x720'

export type extra_images = ExtraImages

export const get_default_data_src: () => ImageSize = () => 'full'
export const get_default_data_srcset: () => [ImageSize, string][] = () => [
]

// 425
export const newpageheader_src: () => ImageSize = () => '425w'
export const newpageheader_srcset: () => [ImageSize, string][] = () => [
  ['425w', '425w'],
  ['850w', '850w'],
  ['1225w', '1225w'],
]

// ----- 460w

export const mediablock_src: () => ImageSize = () => 'media'
export const mediablock_srcset: () => [ImageSize, string][] = () => [
  ['920w', 'media'],
  ['1840w', '1840w']
]

// ----- 700w

export const ctablock_src: () => ImageSize = () => '700w'
export const ctablock_srcset: () => [ImageSize, string][] = () => [
  ['700w', '700w'],
  ['1400w', '1400w'],
  ['2800w', '2800w'],
]

// ----- 720

export const linkgridblock_src: () => ImageSize = () => 'grid'
export const linkgridblock_srcset: () => [ImageSize, string][] = () => [
  ['grid', '720w'],
  ['full', 'full']
]

export const textimageblock_src: () => ImageSize = () => '720w'
export const textimageblock_srcset: () => [ImageSize, string][] = () => [
  ['720w', '720w'],
  ['1440w', '1440w'],
]

export const timelineblock_src: () => ImageSize = () => '450x450'
export const timelineblock_srcset: () => [ImageSize, string][] = () => [
  ['450x450', '450x450'],
  ['600x600', '600x600'],
  ['1200x1200', '1200x1200']
]

export const quotesblock_src: () => ImageSize = () => '450x450'
export const quotesblock_srcset: () => [ImageSize, string][] = () => [
  ['450x450', '450x450'],
  ['600x600', '600x600'],
  ['1200x1200', '1200x1200']
]

// ----- OLD PROJECT - not needed

export const featuredblock_src: () => ImageSize = () => '640w'
export const featuredblock_srcset: () => [ImageSize, string][] = () => [
  ['640w', '640w'],
  ['1280w', '1280w'],
  ['1920w', '1920w'],
  ['2880w', '2880w']
]

export const gallery_src: () => ImageSize = () => '1280w'
export const gallery_srcset: () => [ImageSize, string][] = () => [
  ['1280w', '1280w'],
  ['1920w', '1920w'],
  ['2880w', '2880w']
]

export const quoteblock_src: () => ImageSize = () => '640x360'
export const quoteblock_srcset: () => [ImageSize, string][] = () => [
  ['640x360', '640w'],
  ['1280x720', '1280w']
]

export const overviewpage_src: () => ImageSize = () => 'thumbnail'
export const overviewpage_srcset: () => [ImageSize, string][] = () => [
  ['thumbnail', '150w'],
  ['medium_large' as ExtraImages, '700w'],
  ['large', '920w']
]
